import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { useStoreCategory, StoreCategory } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => (
  <GenericFormPage<StoreCategory>
    useData={useStoreCategory}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
